import { cn } from "@/utils/cn";
import { IonIcon, useIonRouter } from "@ionic/react";
import { informationCircleOutline } from "ionicons/icons";

interface PlanInfoIconLinkProps {
  to: string;
  label?: string;

  className?: string;
}

export const PlanInfoIconLink = ({
  to,
  label,
  className,
}: PlanInfoIconLinkProps) => {
  const navigation = useIonRouter();

  return (
    <button
      type="button"
      onClick={() => navigation.push(to)}
      className={cn(
        "inline-flex items-center gap-1 text-sm text-gray-700 hover:text-black",
        className,
      )}
    >
      <IonIcon icon={informationCircleOutline} className="text-base" />
      {label && <span className="underline decoration-dotted">{label}</span>}
    </button>
  );
};
